// extracted by mini-css-extract-plugin
export default {"imageWrapper":"aX-z","hovered":"bX-z","hoverImage":"cX-z","mainImage":"dX-z","imageNoBackground":"eX-z","fullSizeImage":"fX-z"};